import React, { useState } from "react";
import axios from "axios";
import { Bell, Check } from "lucide-react";
import { API } from "../../config";
import { useAuth } from "../../AuthContext";

/** "Notify me when ChatGPT support (OAuth sign-in) is live" — stores the address with source mcp_chatgpt_waitlist. */
export default function McpChatGptWaitlist() {
  const { user, authHeader } = useAuth() || {};
  const [email, setEmail] = useState("");
  const [state, setState] = useState({ busy: false, done: null, error: null });
  const submit = async (e) => {
    e?.preventDefault();
    setState({ busy: true, done: null, error: null });
    try {
      const { data } = await axios.post(`${API}/mcp/chatgpt-waitlist`, { email: user ? undefined : email.trim() }, { headers: authHeader ? authHeader() : {} });
      setState({ busy: false, done: data, error: null });
    } catch (err) {
      const s = err?.response?.status;
      setState({ busy: false, done: null, error: s === 429 ? "Too many requests — try again in an hour." : (err?.response?.data?.detail || "Something went wrong — please try again.") });
    }
  };
  if (state.done) {
    return <p data-testid="mcp-chatgpt-waitlist-done" style={{ margin: "12px 0 0", display: "flex", gap: 8, alignItems: "center", fontSize: 13, color: "#047857", fontWeight: 600 }}><Check style={{ width: 14, height: 14 }} />{state.done.already_listed ? "You're already on the list — we'll email you at launch." : state.done.message}</p>;
  }
  const btn = { background: "#191c1d", color: "#fff", border: "none", borderRadius: 999, padding: "10px 18px", fontSize: 13, fontWeight: 700, cursor: state.busy ? "wait" : "pointer", display: "inline-flex", alignItems: "center", gap: 8, opacity: state.busy ? 0.7 : 1 };
  return (
    <form onSubmit={submit} data-testid="mcp-chatgpt-waitlist-form" style={{ marginTop: 12, display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
      {!user && (
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@company.com" data-testid="mcp-chatgpt-waitlist-email"
          style={{ flex: "1 1 220px", background: "#fff", border: "1px solid #e8ecee", borderRadius: 999, padding: "10px 16px", fontSize: 13, color: "#191c1d", outline: "none" }} />
      )}
      <button type="submit" disabled={state.busy} data-testid="mcp-chatgpt-waitlist-submit" style={btn}>
        <Bell style={{ width: 14, height: 14 }} />{user ? `Notify me at ${user.email}` : "Notify me when ChatGPT support is live"}
      </button>
      {state.error && <p data-testid="mcp-chatgpt-waitlist-error" style={{ margin: 0, fontSize: 12, color: "#b91c1c", flexBasis: "100%" }}>{state.error}</p>}
    </form>
  );
}
